import type { Theme } from './types';

export const crtLightTheme: Theme = {
  name: 'CRT Light',
  id: 'crt-light',
  colours: {
    background: {
      primary: '#f0f2f5',
      secondary: '#e8eaed',
      tertiary: '#e0e2e5',
      elevated: '#d8dadd',
    },
    text: {
      primary: '#0a4a2e',
      secondary: '#0d5a38',
      tertiary: '#106a42',
      inverse: '#f0f2f5',
    },
    accent: {
      primary: '#059669',
      secondary: '#0284c7',
      success: '#059669',
      warning: '#d97706',
      error: '#dc2626',
    },
    feedback: {
      placed: '#059669',
      misplaced: '#d97706',
      incorrect: '#94a3b8',
    },
    rarity: {
      common: '#64748b',
      uncommon: '#16a34a',
      rare: '#2563eb',
      epic: '#9333ea',
      legendary: '#ca8a04',
    },
    powerUp: {
      boost: '#14b8a6',
      surge_i: '#ec4899',
      surge_ii: '#ec4899',
      oracle: '#dc2626',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: "'Courier New', 'Lucida Console', monospace",
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  borders: {
    radius: {
      sm: '0.125rem',
      md: '0.25rem',
      lg: '0.375rem',
      full: '9999px',
    },
    width: {
      thin: '1px',
      normal: '2px',
      thick: '3px',
    },
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.1)',
    md: '0 2px 4px rgba(0, 0, 0, 0.1)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.12)',
    xl: '0 8px 16px rgba(0, 0, 0, 0.15)',
    glow: '0 0 12px rgba(5, 150, 105, 0.2)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  scanlineAlpha: 0.04,
  vignetteEnabled: true,
  fontFamily: "'Courier New', 'Lucida Console', monospace",
  rarityColours: {
    common: '#64748b',
    uncommon: '#16a34a',
    rare: '#2563eb',
    epic: '#9333ea',
    legendary: '#ca8a04',
  },
  powerUpColours: {
    oracle: '#dc2626',
    surge: '#ec4899',
    boost: '#14b8a6',
  },
};
